import { VFlow } from 'bold-ui'
import React from 'react'

import { AcompanhamentoPreNatalTabs } from './AcompanhamentoPreNatalTabs'
import { AntecedentesObstetricosCard } from './components/AntecedentesObstetricosCard'
import { ExternalPaths } from './model-acompanhamentoPreNatal'

interface AcompanhamentoPreNatalContentProps {
  prontuarioId: ID
  atendimentoId: ID
  cidadaoId: ID
  dataReferencia: Instant
  externalPaths: ExternalPaths
  isVisualizacaoProntuario: boolean
}

export function AcompanhamentoPreNatalContent(props: AcompanhamentoPreNatalContentProps) {
  const { prontuarioId, atendimentoId, cidadaoId, dataReferencia, externalPaths, isVisualizacaoProntuario } = props

  return (
    <VFlow>
      <AntecedentesObstetricosCard prontuarioId={prontuarioId} />
      <AcompanhamentoPreNatalTabs
        cidadaoId={cidadaoId}
        prontuarioId={prontuarioId}
        atendimentoId={atendimentoId}
        dataReferencia={dataReferencia}
        externalPaths={externalPaths}
        isVisualizacaoProntuario={isVisualizacaoProntuario}
      />
    </VFlow>
  )
}
